import $ from 'jquery';
import 'slick-carousel';

function initGridSlider() {
  let gridRows = 1
  let slidesPerRow = 1
  let slidesToScroll = 1
  let slidesToShow = 1.5
  if ($('.ucg-grid-slider-block .slides .inset').length) {
    if ($(window).width() >= 960) {
      gridRows = 3
      slidesPerRow = 1;
      slidesToScroll = 1;
      slidesToShow = 3;
    }
    $('.ucg-grid-slider-block .slides .inset.slick-initialized').slick('unslick')
    if ($('.ucg-grid-slider-block .slides .inset').find('.slide-2').length) {
      $('.ucg-grid-slider-block .slides .inset').not('.slick-initialized').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 7500,
        dots: false,
        infinite: false,
        nextArrow: '<div class="slick-next"><i class="fa fa-arrow-right"></i></div>',
        prevArrow: '<div class="slick-prev"><i class="fa fa-arrow-left"></i></div>',
        rows: gridRows,
        slidesPerRow: slidesPerRow,
        slidesToScroll: slidesToScroll,
        slidesToShow: slidesToShow,
        speed: 1000
      });
    }
  };
}
$(window).on('load resize', function() {
  initGridSlider()
});